import { put, call, takeEvery } from 'redux-saga/effects'
import { RestHelper } from '../helpers/RestHelper'
import * as StatsActions from '../actions/StatsActions'

const getTopNScoresLeaderboardFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N scores.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/leaderboards/v1.0/leaderboards/topnscores?count=${StatsActions.MAX_LEADERBOARD_ENTRIES}`, false)

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_TOP_N_SCORES_LEADERBOARD_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_TOP_N_SCORES_LEADERBOARD_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_TOP_N_SCORES_LEADERBOARD_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getTopNPlaysLeaderboardFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N plays.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/leaderboards/v1.0/leaderboards/topnplays?count=${StatsActions.MAX_LEADERBOARD_ENTRIES}`, false)

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_TOP_N_PLAYS_LEADERBOARD_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_TOP_N_PLAYS_LEADERBOARD_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_TOP_N_PLAYS_LEADERBOARD_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getTopNNotechartArtistsLeaderboardFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N notechart artists.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/leaderboards/v1.0/leaderboards/topnnotechartartists?count=${StatsActions.MAX_LEADERBOARD_ENTRIES}`, false)

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getTopNChartsPerYearLeaderboardFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N plays.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/leaderboards/v1.0/leaderboards/topnnotechartsplayedperyear?count=${StatsActions.MAX_LEADERBOARD_ENTRIES}`, false)

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getTopNChartsPerYearAndMonthLeaderboardFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N plays.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/leaderboards/v1.0/leaderboards/topnnotechartsplayedperyearandmonth?count=${StatsActions.MAX_LEADERBOARD_ENTRIES}`, false)

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getTopNSongsPerYearLeaderboardFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N plays.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/leaderboards/v1.0/leaderboards/topnsongsplayedperyear?count=${StatsActions.MAX_LEADERBOARD_ENTRIES}`, false)

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getTopNSongsPerYearAndMonthLeaderboardFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N plays.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/leaderboards/v1.0/leaderboards/topnsongsplayedperyearandmonth?count=${StatsActions.MAX_LEADERBOARD_ENTRIES}`, false)

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getUserPlaysOverTimeStatsFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N scores.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/users/v1.0/user/profile/stats/playsovertime`)

        if (response.status == 200) {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_USER_PLAYS_OVER_TIME_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else if (response.status == 204) {
            let json = { results: [] }
            yield put({type: StatsActions.GET_USER_PLAYS_OVER_TIME_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_USER_PLAYS_OVER_TIME_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_USER_PLAYS_OVER_TIME_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getUserPlaysPerTimeOfDayStatsFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N scores.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/users/v1.0/user/profile/stats/playspertimeofday`)

        if (response.status == 200) {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_USER_PLAYS_PER_TIME_OF_DAY_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else if (response.status == 204) {
            let json = { results: [] }
            yield put({type: StatsActions.GET_USER_PLAYS_PER_TIME_OF_DAY_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_USER_PLAYS_PER_TIME_OF_DAY_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_USER_PLAYS_PER_TIME_OF_DAY_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getUserMaxDifficultyPassesOverTimeStatsFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N scores.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/users/v1.0/user/profile/stats/maxdifficultypasses`)

        if (response.status == 200) {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else if (response.status == 204) {
            let json = { results: [] }
            yield put({type: StatsActions.GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getUserScoresTakenLeaderboardFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N plays.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/leaderboards/v1.0/leaderboards/userscorestaken?count=${StatsActions.MAX_USER_SCORES_TAKEN_LEADERBOARD_ENTRIES}`, false)

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_USER_SCORES_TAKEN_LEADERBOARD_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_USER_SCORES_TAKEN_LEADERBOARD_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_USER_SCORES_TAKEN_LEADERBOARD_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getUserSeasonsProgressStatsFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N scores.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/users/v1.0/user/profile/stats/seasons/scoreprogress`)

        if (response.status == 200) {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_USER_SEASONS_PROGRESS_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else if (response.status == 204) {
            let json = { results: [] }
            yield put({type: StatsActions.GET_USER_SEASONS_PROGRESS_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_USER_SEASONS_PROGRESS_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_USER_SEASONS_PROGRESS_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getUserRecommendedRivalsStatsFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N scores.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/users/v1.0/user/profile/stats/rivals/recommended`)

        if (response.status == 200) {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_USER_RECOMMENDED_RIVALS_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else if (response.status == 204) {
            let json = {}
            yield put({type: StatsActions.GET_USER_RECOMMENDED_RIVALS_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_USER_RECOMMENDED_RIVALS_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_USER_RECOMMENDED_RIVALS_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getUserNextScoresToTakeStatsFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N scores.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/users/v1.0/user/profile/stats/scores/nexttotake?count=25`)

        if (response.status == 200) {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_USER_NEXT_SCORES_TO_TAKE_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else if (response.status == 204) {
            let json = {}
            yield put({type: StatsActions.GET_USER_NEXT_SCORES_TO_TAKE_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_USER_NEXT_SCORES_TO_TAKE_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_USER_NEXT_SCORES_TO_TAKE_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getUserPackProgressStatsFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the pack progress (hard code the beginner pack for now).
        // TODO(dirtypiece): Make these packs configurable by the user in the future.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/users/v1.0/user/profile/stats/packs/d87fa54e-6e4d-4d53-9bfe-11a8beb0c5c1/scoreprogress`)

        if (response.status == 200) {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_USER_PACK_PROGRESS_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else if (response.status == 204) {
            let json = {
                results: {
                    packExternalId: "",
                    packName: "",
                    totalSinglesChartsCount: 0,
                    totalDoublesChartsCount: 0,
                    singlesChartsPurpleAwardCount: 0,
                    doublesChartsPurpleAwardCount: 0,
                    singlesChartsBlueAwardCount: 0,
                    doublesChartsBlueAwardCount: 0,
                    singlesChartsGreenAwardCount: 0,
                    doublesChartsGreenAwardCount: 0,
                    singlesChartsYellowAwardCount: 0,
                    doublesChartsYellowAwardCount: 0,
                    singlesChartsRedAwardCount: 0,
                    doublesChartsRedAwardCount: 0,
                }
            }
            
            yield put({type: StatsActions.GET_USER_PACK_PROGRESS_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_USER_PACK_PROGRESS_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_USER_PACK_PROGRESS_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getTopNPlaysPerCountryLeaderboardFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the top N plays.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/leaderboards/v1.0/leaderboards/countries/topnplays?count=${StatsActions.MAX_PLAYS_PER_COUNTRY_LEADERBOARD_ENTRIES}`, false)

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: StatsActions.GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: StatsActions.GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: StatsActions.GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_FAILED_ACTION_TYPE, message: e.message});
    }
}

export const getTopNScoresLeaderboardFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_TOP_N_SCORES_LEADERBOARD_ACTION_TYPE, getTopNScoresLeaderboardFromServer);
}

export const getTopNPlaysLeaderboardFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_TOP_N_PLAYS_LEADERBOARD_ACTION_TYPE, getTopNPlaysLeaderboardFromServer);
}

export const getTopNNotechartArtistsLeaderboardFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_ACTION_TYPE, getTopNNotechartArtistsLeaderboardFromServer);
}

export const getTopNChartsPerYearLeaderboardFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_ACTION_TYPE, getTopNChartsPerYearLeaderboardFromServer);
}

export const getTopNChartsPerYearAndMonthLeaderboardFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_ACTION_TYPE, getTopNChartsPerYearAndMonthLeaderboardFromServer);
}

export const getTopNSongsPerYearLeaderboardFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_ACTION_TYPE, getTopNSongsPerYearLeaderboardFromServer);
}

export const getTopNSongsPerYearAndMonthLeaderboardFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_ACTION_TYPE, getTopNSongsPerYearAndMonthLeaderboardFromServer);
}

export const getUserPlaysOverTimeActionFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_USER_PLAYS_OVER_TIME_ACTION_TYPE, getUserPlaysOverTimeStatsFromServer);
}

export const getUserPlaysPerTimeOfDayActionFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_USER_PLAYS_PER_TIME_OF_DAY_ACTION_TYPE, getUserPlaysPerTimeOfDayStatsFromServer);
}

export const getUserMaxDifficultyPassesOverTimeActionFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_ACTION_TYPE, getUserMaxDifficultyPassesOverTimeStatsFromServer);
}

export const getUserScoresTakenLeaderboardFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_USER_SCORES_TAKEN_LEADERBOARD_ACTION_TYPE, getUserScoresTakenLeaderboardFromServer);
}

export const getUserSeasonsProgressActionFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_USER_SEASONS_PROGRESS_ACTION_TYPE, getUserSeasonsProgressStatsFromServer);
}

export const getUserRecommendedRivalsActionFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_USER_RECOMMENDED_RIVALS_ACTION_TYPE, getUserRecommendedRivalsStatsFromServer);
}

export const getUserNextScoresToTakeFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_USER_NEXT_SCORES_TO_TAKE_ACTION_TYPE, getUserNextScoresToTakeStatsFromServer);
}

export const getUserPackProgressActionFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_USER_PACK_PROGRESS_ACTION_TYPE, getUserPackProgressStatsFromServer);
}

export const getTopNPlaysByCountryLeaderboardFromServerSaga = function*() {
    yield takeEvery(StatsActions.GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_ACTION_TYPE, getTopNPlaysPerCountryLeaderboardFromServer);
}